// extracted by mini-css-extract-plugin
export default {"logout-message-color":"logout-message-color--EdkSXvLo","logoutMessageColor":"logout-message-color--EdkSXvLo"};